import React, { useState, useEffect, useCallback } from 'react';
import { getPopularTags, getFreshTags, getRisingTags } from '../lib/tags';
import { TagDetail } from './TagDetail';
import { COLORS, SPACING } from '../styles/theme';

export function Tags({ onBack, onViewUserProfile, onViewVideo }: { onBack: () => void; onViewUserProfile: (userId: string) => void; onViewVideo: (hash: string) => void }) {
  const [tagType, setTagType] = useState<'popular' | 'fresh' | 'rising'>('popular');
  const [tags, setTags] = useState<any[]>([]);
  const [selectedTag, setSelectedTag] = useState<string | null>(null);

  const loadTags = useCallback(() => {
    let loaded;
    if (tagType === 'popular') loaded = getPopularTags(50);
    else if (tagType === 'fresh') loaded = getFreshTags(50);
    else loaded = getRisingTags(50);
    
    setTags(loaded);
  }, [tagType]);

  useEffect(() => {
    loadTags();
  }, [loadTags]);

  if (selectedTag) {
    return (
      <TagDetail
        tag={selectedTag}
        onBack={() => setSelectedTag(null)}
        onViewUserProfile={onViewUserProfile}
        onViewVideo={onViewVideo}
      />
    );
  }

  return (
    <div style={{
      border: `2px outset ${COLORS.highlight}`,
      backgroundColor: COLORS.panel,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      <div style={{
        backgroundColor: COLORS.accent,
        color: '#fff',
        padding: `${SPACING.xs} ${SPACING.sm}`,
        fontSize: '9px',
        fontWeight: 700,
        borderBottom: `2px solid ${COLORS.highlight}`,
        userSelect: 'none'
      }}>
        Tags
      </div>

      <div style={{
        padding: SPACING.lg,
        backgroundColor: COLORS.bg,
        borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex',
        gap: SPACING.sm
      }}>
        {['popular', 'fresh', 'rising'].map(type => (
          <button
            key={type}
            onClick={() => setTagType(type as any)}
            style={{
              padding: `${SPACING.sm} ${SPACING.lg}`,
              backgroundColor: tagType === type ? COLORS.accent : COLORS.panel,
              color: tagType === type ? '#fff' : COLORS.text,
              border: `2px outset ${tagType === type ? COLORS.accent : COLORS.highlight}`,
              cursor: 'pointer',
              fontFamily: 'monospace',
              fontSize: '9px',
              fontWeight: 700,
              textDecoration: 'underline',
              textTransform: 'capitalize',
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.5)'
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.borderStyle = 'inset';
              e.currentTarget.style.boxShadow = 'inset 1px 1px 2px rgba(0,0,0,0.8)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.borderStyle = 'outset';
              e.currentTarget.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.5)';
            }}
          >
            {type}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflowY: 'auto', backgroundColor: COLORS.bg, padding: SPACING.lg }}>
        {tags.length === 0 ? (
          <p style={{ color: COLORS.textMuted, fontSize: '10px', margin: 0 }}>
            No tags
          </p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: SPACING.lg }}>
            {tags.map((item, idx) => (
              <button
                key={idx}
                onClick={() => setSelectedTag(item.tag)}
                style={{
                  padding: SPACING.lg,
                  backgroundColor: COLORS.panel,
                  color: COLORS.text,
                  border: `2px outset ${COLORS.highlight}`,
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontFamily: 'monospace',
                  fontSize: '9px',
                  fontWeight: 700,
                  textDecoration: 'underline',
                  boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.5)'
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.borderStyle = 'inset';
                  e.currentTarget.style.boxShadow = 'inset 1px 1px 2px rgba(0,0,0,0.8)';
                }}
                onMouseUp={(e) => {
                  e.currentTarget.style.borderStyle = 'outset';
                  e.currentTarget.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.5)';
                }}
              >
                <h4 style={{ margin: `0 0 ${SPACING.sm} 0`, color: COLORS.accent, fontStyle: 'italic' }}>
                  {item.tag}
                </h4>
                <p style={{ margin: 0, fontSize: '8px', color: COLORS.textMuted }}>
                  {tagType === 'rising' ? `📈 ${Math.round(item.momentum)}` : `📌 ${item.count}`}
                </p>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
